/* ============================================================
   AUREO — aureo.js  (ES5/ES6 compatible — no optional chaining)
   ============================================================ */

(function () {
  'use strict';

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function prefersReduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function isTouch()        { return window.matchMedia('(hover: none)').matches; }
  function safeOn(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function initCursor() {
    if (isTouch()) return;
    var cursor = qs('#cursor');
    if (!cursor) return;
    var mx = 0, my = 0, cx = 0, cy = 0, moved = false;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!moved) { moved = true; cx = mx; cy = my; cursor.classList.add('ready'); }
    });
    function lerp(a, b, n) { return (1 - n) * a + n * b; }
    function loop() {
      cx = lerp(cx, mx, 0.2); cy = lerp(cy, my, 0.2);
      cursor.style.left = cx + 'px'; cursor.style.top = cy + 'px';
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    document.addEventListener('mouseenter', function () { if (moved) cursor.classList.remove('hide'); });
    document.addEventListener('mouseleave', function () { cursor.classList.add('hide'); });
    document.addEventListener('mouseover', function (e) {
      var el = e.target;
      while (el && el !== document) {
        if (el.matches && el.matches('a, button, [data-cursor], input, select, textarea, label')) {
          cursor.classList.add('big'); return;
        }
        el = el.parentElement;
      }
      cursor.classList.remove('big');
    });
  }

  function initHeader() {
    var header = qs('.site-header');
    if (!header) return;
    // On non-home pages the header is already solid (set server-side).
    // Only run the scroll-based toggle on the home page.
    if (!window.AUREO_IS_HOME) return;
    var ticking = false;
    function update() { header.classList.toggle('site-header--solid', window.scrollY > 70); ticking = false; }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initMarquees() {
    qsa('.marquee').forEach(function (mq) {
      var track = mq.querySelector('.marquee-track');
      if (!track) return;
      if (!track.dataset.doubled) { track.innerHTML += track.innerHTML; track.dataset.doubled = '1'; }
    });
  }

  function initReveal() {
    if (prefersReduced()) { qsa('[data-reveal], .clip-reveal').forEach(function (el) { el.classList.add('in'); }); return; }
    if (!('IntersectionObserver' in window)) { qsa('[data-reveal], .clip-reveal').forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    qsa('[data-reveal], .clip-reveal').forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (prefersReduced() || isTouch()) return;
    var els = qsa('[data-parallax]');
    if (!els.length) return;
    function update() {
      var scrollY = window.scrollY;
      els.forEach(function (el) {
        var speed = parseFloat(el.dataset.speed || '0.2');
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var offset = (window.innerHeight / 2 - center) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      });
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    update();
  }

  function initDrift() {
    if (prefersReduced()) return;
    var els = qsa('[data-drift]');
    if (!els.length) return;
    function update() {
      els.forEach(function (el) {
        var dist = parseFloat(el.dataset.distance || '0');
        var rect = el.getBoundingClientRect();
        var pct = 1 - (rect.top / window.innerHeight);
        el.style.transform = 'translateX(' + (dist * pct * 0.5) + 'px)';
      });
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    update();
  }

  function initMagnetic() {
    if (isTouch()) return;
    qsa('.btn').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        btn.style.transform = 'translate(' + (dx * 0.35) + 'px, ' + (dy * 0.35) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  function initPageWipe() {
    if (prefersReduced()) return;
    var wipe = qs('#wipe');
    if (!wipe) return;
    document.addEventListener('click', function (e) {
      var link = e.target;
      while (link && link.tagName !== 'A') { link = link.parentElement; }
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('javascript') === 0 ||
          href.indexOf('mailto') === 0 || href.indexOf('tel') === 0 ||
          link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;
      try { if (new URL(link.href, location.origin).origin !== location.origin) return; } catch (err) { return; }
      e.preventDefault();
      wipe.classList.add('run');
      var dest = link.href;
      setTimeout(function () { window.location.href = dest; }, 430);
    });
  }

  function initCountdown() {
    qsa('[data-countdown-target]').forEach(function (chip) {
      var target = new Date(chip.dataset.countdownTarget).getTime();
      var dEl = chip.querySelector('[data-countdown-d]');
      var hEl = chip.querySelector('[data-countdown-h]');
      var mEl = chip.querySelector('[data-countdown-m]');
      var sEl = chip.querySelector('[data-countdown-s]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return (Math.max(0, n) < 10 ? '0' : '') + Math.max(0, n); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { dEl.textContent = hEl.textContent = mEl.textContent = sEl.textContent = '00'; return; }
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick(); setInterval(tick, 1000);
    });
  }

  var Toast = {
    el: null, msgEl: null, timer: null,
    init: function () { this.el = qs('#toast'); this.msgEl = qs('#toast-msg'); },
    show: function (msg, duration) {
      if (!this.el) return;
      duration = duration || 3000;
      if (this.msgEl) this.msgEl.textContent = msg;
      this.el.classList.add('toast--visible');
      clearTimeout(this.timer);
      var self = this;
      this.timer = setTimeout(function () { self.el.classList.remove('toast--visible'); }, duration);
    }
  };

  var Cart = {
    drawer: null, scrim: null, countEls: null,
    init: function () {
      this.drawer = qs('#cart-drawer');
      this.scrim = qs('#cart-scrim');
      this.countEls = qsa('#cart-count');
      if (!this.drawer) return;
      var self = this;
      safeOn(qs('#cart-close'), 'click', function () { self.close(); });
      safeOn(this.scrim, 'click', function () { self.close(); });
      qsa('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', function () { self.open(); }); });
      document.addEventListener('aureo:cart-updated', function () { self.refresh(); });
      this.updateCount();
    },
    open: function () {
      if (!this.drawer) return;
      this.drawer.classList.add('open');
      this.drawer.setAttribute('aria-hidden', 'false');
      if (this.scrim) this.scrim.classList.add('visible');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (this.scrim) this.scrim.classList.remove('visible');
      document.body.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { self.render(cart); }).catch(function (e) { console.warn('Cart refresh failed', e); });
    },
    updateCount: function () {
      var self = this;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        self.countEls.forEach(function (el) { el.textContent = cart.item_count; });
      }).catch(function () {});
    },
    render: function (cart) {
      var itemsContainer = qs('#cart-items');
      var emptyState = qs('#cart-empty');
      var filledState = qs('#cart-filled');
      var headerCount = qs('#cart-header-count');
      var subtotalEl = qs('#cart-subtotal');
      var shippingFill = qs('#cart-shipping-fill');
      var shippingLabel = qs('#cart-shipping-label');
      var FREE = window.AUREO_FREE_SHIPPING || 2000;
      if (headerCount) headerCount.textContent = 'Your Bag — ' + cart.item_count;
      this.countEls.forEach(function (el) { el.textContent = cart.item_count; });
      if (cart.item_count === 0) {
        if (emptyState) emptyState.style.display = 'flex';
        if (filledState) filledState.style.display = 'none';
        return;
      }
      if (emptyState) emptyState.style.display = 'none';
      if (filledState) filledState.style.display = 'flex';
      var subtotalCents = cart.total_price;
      var subtotalE = (subtotalCents / 100).toFixed(2).replace('.', ',');
      if (subtotalEl) subtotalEl.textContent = 'EGP ' + subtotalE;
      var pct = Math.min(100, (subtotalCents / (FREE * 100)) * 100);
      if (shippingFill) shippingFill.style.width = pct + '%';
      if (shippingLabel) {
        var remaining = Math.max(0, FREE - subtotalCents / 100);
        shippingLabel.textContent = remaining <= 0 ? '❖ Free shipping unlocked' : 'EGP ' + Math.ceil(remaining) + ' to free shipping';
      }
      if (!itemsContainer) return;
      itemsContainer.innerHTML = cart.items.map(function (item) {
        var isDark = (item.variant_title && item.variant_title.indexOf('Obsidian') > -1) || (item.product_title && item.product_title.indexOf('Black') > -1);
        var bg = isDark ? '#161614' : '#e6dfd0';
        var imgHtml = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || '') + '" style="width:100%;height:100%;object-fit:cover;">' : '';
        var linePrice = ((item.line_price) / 100).toFixed(2).replace('.', ',');
        return '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item-thumb" style="background:' + bg + ';">' + imgHtml + '</div>' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-row"><span class="cart-item-name display">' + (item.product_title || '') + '</span><span class="cart-item-price">EGP ' + linePrice + '</span></div>' +
            '<div class="cart-item-meta kicker">' + (item.variant_title || 'One Size') + '</div>' +
            '<div class="cart-item-controls">' +
              '<div class="cart-qty-stepper">' +
                '<button class="cart-qty-btn" data-action="dec" data-key="' + item.key + '" data-qty="' + item.quantity + '">–</button>' +
                '<span class="cart-qty-val">' + item.quantity + '</span>' +
                '<button class="cart-qty-btn" data-action="inc" data-key="' + item.key + '" data-qty="' + item.quantity + '">+</button>' +
              '</div>' +
              '<button class="cart-remove kicker" data-key="' + item.key + '">Remove</button>' +
            '</div>' +
          '</div></div>';
      }).join('');
      var self = this;
      qsa('.cart-qty-btn', itemsContainer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.dataset.key;
          var qty = parseInt(btn.dataset.qty, 10) || 1;
          var newQty = btn.dataset.action === 'inc' ? qty + 1 : Math.max(0, qty - 1);
          self.changeItem(key, newQty);
        });
      });
      qsa('.cart-remove', itemsContainer).forEach(function (btn) {
        btn.addEventListener('click', function () { self.changeItem(btn.dataset.key, 0); });
      });
    },
    addItem: function (variantId, qty, productTitle, size) {
      var self = this;
      var numericId = parseInt(variantId, 10) || variantId;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: numericId, quantity: qty || 1 }] })
      }).then(function (r) {
        var status = r.status;
        return r.json().then(function (data) {
          if (!r.ok) {
            var errMsg = (data && (data.description || data.message)) || 'Could not add to bag — please try again.';
            Toast.show(errMsg, 5000);
            return;
          }
          self.updateCount();
          document.dispatchEvent(new CustomEvent('aureo:cart-updated'));
          var msg = productTitle + (size ? ' — ' + size : '') + ' added to your bag';
          Toast.show(msg);
          self.open();
        });
      }).catch(function (e) {
        Toast.show('Network error — please try again.', 4000);
      });
    },
    changeItem: function (key, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () { self.refresh(); self.updateCount(); }).catch(function (e) { console.warn('Cart change failed', e); });
    }
  };

  var WaitlistModal = {
    overlay: null, form: null, step1: null, step2: null,
    init: function () {
      this.overlay = qs('#waitlist-modal');
      if (!this.overlay) return;
      this.form = qs('#waitlist-form');
      this.step1 = qs('#waitlist-step1');
      this.step2 = qs('#waitlist-step2');
      var self = this;
      qsa('[data-waitlist-trigger]').forEach(function (btn) { btn.addEventListener('click', function () { self.open(); }); });
      safeOn(qs('#waitlist-close'), 'click', function () { self.close(); });
      safeOn(qs('#waitlist-continue'), 'click', function () { self.close(); });
      var scrim = this.overlay.querySelector('.modal-scrim');
      safeOn(scrim, 'click', function () { self.close(); });
      if (this.form) {
        this.form.addEventListener('submit', function (e) {
          e.preventDefault();
          var emailInput = self.form.querySelector('input[type="email"]');
          var email = emailInput ? emailInput.value : '';
          if (!email || email.indexOf('@') === -1) return;
          self.submitForm(email);
        });
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.overlay.classList.contains('open')) self.close(); });
    },
    open: function () {
      if (this.step1) this.step1.style.display = '';
      if (this.step2) this.step2.style.display = 'none';
      if (this.form) this.form.reset();
      this.overlay.classList.add('open');
      this.overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      this.overlay.classList.remove('open');
      this.overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    submitForm: function (email) {
      var klaviyoList = window.AUREO_KLAVIYO_LIST;
      var klaviyoCompany = window.AUREO_KLAVIYO_COMPANY;
      if (klaviyoList && klaviyoCompany) {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCompany, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, list_id: klaviyoList }}})
        }).catch(function () {});
      }
      if (this.step1) this.step1.style.display = 'none';
      if (this.step2) this.step2.style.display = '';
    }
  };

  var SizeGuideModal = {
    overlay: null,
    init: function () {
      this.overlay = qs('#size-guide-modal');
      if (!this.overlay) return;
      var self = this;
      qsa('[data-size-guide]').forEach(function (btn) { btn.addEventListener('click', function () { self.open(); }); });
      safeOn(qs('#size-guide-close'), 'click', function () { self.close(); });
      var scrim = this.overlay.querySelector('.modal-scrim');
      safeOn(scrim, 'click', function () { self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.overlay.classList.contains('open')) self.close(); });
    },
    open: function () { this.overlay.classList.add('open'); this.overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; },
    close: function () { this.overlay.classList.remove('open'); this.overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  };

  function initMobileMenu() {
    var menu = qs('#mobile-menu');
    var ham = qs('.ham');
    var closeBtn = qs('.mobile-menu-close');
    if (!menu || !ham) return;
    function openMenu() {
      menu.classList.add('open'); ham.classList.add('open');
      ham.setAttribute('aria-expanded', 'true'); menu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      qsa('.mobile-nav-link', menu).forEach(function (link, i) {
        if (!prefersReduced()) { link.style.animation = 'aureo-rise .7s var(--ease) ' + (i * 60) + 'ms both'; }
      });
    }
    function closeMenu() {
      menu.classList.remove('open'); ham.classList.remove('open');
      ham.setAttribute('aria-expanded', 'false'); menu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    ham.addEventListener('click', function () { if (menu.classList.contains('open')) closeMenu(); else openMenu(); });
    safeOn(closeBtn, 'click', closeMenu);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('open')) closeMenu(); });
    qsa('.mobile-nav-link', menu).forEach(function (link) { link.addEventListener('click', closeMenu); });
  }

  function initProductPage() {
    var page = qs('[data-product-page]');
    if (!page) return;
    var hasColors = page.dataset.hasColors === 'true';
    var allVariants = window.AUREO_VARIANTS || [];
    var sizeButtons = qsa('.size-btn');
    var colourBtns = qsa('.colourway-btn');
    var colourLabelEl = qs('#selected-colour-label');
    var addBtn = qs('#add-to-bag');
    var addBtnWrap = qs('#add-btn-wrap');
    var stickyBar = qs('#sticky-add');
    var stickyAddBtn = qs('#sticky-add-btn');
    var sizeLabelEl = qs('#size-label');
    var mainImg = qs('#product-main-img');
    var thumbnails = qsa('.product-thumb');
    var qtyDisplay = qs('#qty-display');
    var qtyDec = qs('#qty-dec');
    var qtyInc = qs('#qty-inc');
    var accordions = qsa('.accordion');
    var selectedSize = null;
    var selectedColour = window.AUREO_INITIAL_COLOUR || null;
    var selectedVariant = null;
    var qty = 1;
    function resolveVariant() {
      if (!selectedSize) return null;
      if (hasColors && !selectedColour) return null;
      for (var i = 0; i < allVariants.length; i++) {
        var v = allVariants[i];
        if ((v.option1 === selectedSize) && (!hasColors || v.option2 === selectedColour)) return v;
      }
      return null;
    }
    function onSelectionChange() {
      var variant = resolveVariant();
      selectedVariant = variant ? variant.id : null;
      if (stickyAddBtn) {
        if (!selectedSize) { stickyAddBtn.textContent = 'Select a Size'; }
        else if (hasColors && !selectedColour) { stickyAddBtn.textContent = 'Select a Colour'; }
        else { stickyAddBtn.textContent = 'Add to Bag — ' + (addBtn ? addBtn.dataset.price : ''); }
      }
    }
    sizeButtons.forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () {
        sizeButtons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selectedSize = btn.dataset.size;
        if (sizeLabelEl) { sizeLabelEl.textContent = 'Size'; sizeLabelEl.classList.remove('error'); }
        if (stickyBar) { var sizeEl = stickyBar.querySelector('.sticky-add-size'); if (sizeEl) sizeEl.textContent = 'Size ' + selectedSize; }
        onSelectionChange();
      });
    });
    colourBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        colourBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var imgSrc = btn.dataset.imgSrc;
        if (mainImg && imgSrc) mainImg.src = imgSrc;
        var colour = btn.dataset.colour;
        if (colour) {
          selectedColour = colour;
          if (colourLabelEl) colourLabelEl.textContent = colour;
          onSelectionChange();
        } else {
          sizeButtons.forEach(function (b) { b.classList.remove('active'); });
          selectedSize = null; selectedVariant = null;
          onSelectionChange();
        }
      });
    });
    function handleAdd() {
      if (!selectedSize) {
        if (sizeLabelEl) { sizeLabelEl.classList.add('error'); sizeLabelEl.textContent = '↓ Pick a size first'; }
        return;
      }
      if (hasColors && !selectedColour) { if (colourLabelEl) colourLabelEl.textContent = '↓ Pick a colour first'; return; }
      if (!selectedVariant) return;
      var label = selectedSize + (selectedColour ? ' / ' + selectedColour : '');
      Cart.addItem(selectedVariant, qty, page.dataset.productTitle, label);
    }
    safeOn(addBtn, 'click', handleAdd);
    safeOn(stickyAddBtn, 'click', handleAdd);
    safeOn(qtyDec, 'click', function () { qty = Math.max(1, qty - 1); if (qtyDisplay) qtyDisplay.textContent = qty; });
    safeOn(qtyInc, 'click', function () { qty++; if (qtyDisplay) qtyDisplay.textContent = qty; });
    if (addBtnWrap && stickyBar && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.style.opacity = visible ? '0' : '1';
        stickyBar.style.pointerEvents = visible ? 'none' : 'auto';
      }, { threshold: 0 });
      io.observe(addBtnWrap);
    }
    thumbnails.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.imgSrc; var alt = btn.dataset.imgAlt || '';
        if (mainImg && src) { mainImg.src = src; mainImg.alt = alt; }
        thumbnails.forEach(function (b) { b.style.outline = '1px solid rgba(0,0,0,.1)'; });
        btn.style.outline = '2px solid var(--ink)';
      });
    });
    accordions.forEach(function (acc) {
      var accBtn = acc.querySelector('.accordion-btn');
      var body = acc.querySelector('.accordion-body');
      var icon = acc.querySelector('.accordion-icon');
      if (!accBtn) return;
      accBtn.addEventListener('click', function () {
        var isOpen = body ? body.classList.toggle('open') : false;
        if (icon) icon.classList.toggle('open', isOpen);
        accBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initCollectionFilter() {
    var filterBtns = qsa('.filter-btn');
    if (!filterBtns.length) return;
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.dataset.filter;
        qsa('.product-card-wrap').forEach(function (card) {
          if (filter === 'all') { card.style.display = ''; }
          else { var tags = (card.dataset.tags || '').toLowerCase(); card.style.display = tags.indexOf(filter) > -1 ? '' : 'none'; }
        });
      });
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target;
      while (btn && !btn.hasAttribute('data-quick-add')) { btn = btn.parentElement; }
      if (!btn || !btn.hasAttribute('data-quick-add')) return;
      e.preventDefault(); e.stopPropagation();
      var variantId = btn.dataset.variantId;
      var title = btn.dataset.productTitle;
      if (!variantId) return;
      Cart.addItem(variantId, 1, title, null);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCursor(); initHeader(); initMarquees(); initReveal(); initParallax(); initDrift();
    initMagnetic(); initPageWipe(); initCountdown();
    Cart.init(); Toast.init(); WaitlistModal.init(); SizeGuideModal.init();
    initMobileMenu(); initProductPage(); initCollectionFilter(); initQuickAdd();
  });

  window.AureoCart = Cart;
  window.AureoToast = Toast;
  window.AureoWaitlist = WaitlistModal;

}());
